const experimentSettingsJson = {
  advancementSchedule: 2,
  regressionSchedule: 1,
  language: "en",
  seed: 42,
  initialDifficulty: 1,
  numberOfLevels: 9,
};
export { experimentSettingsJson };
